module.exports = __webpack_public_path__ + "static/img/3客户至上.c5b41b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们/3客户至上.png
// module id = l//K
// module chunks = 0